import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';
import { Donation } from 'src/app/models/Donation';
import { CommitteeService } from './committee.service';
import { Payment } from 'src/app/models/Payment';
import { ToastService } from 'src/app/util/toast.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  donation: Donation = new Donation;
  donationList: Donation[] = [];
  payment: Payment = new Payment;
  paymentList: Payment[] = [];

  receivedTotal: number = 0;
  committedTotal: number = 0;
  deniedTotal: number = 0;
  receivedTotal2: number = 0;
  committedTotal2: number = 0;
  deniedTotal2: number = 0;

  constructor(private backEnd: BackEndService, private auth: AuthService,
    private cs: CommitteeService, private toast: ToastService) {
  }

  getDonationList() {
    return new Promise((resolve) => {
      let query = [];
      query.push(["committee_id", this.cs.committee.id]);
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.DONATION, query, 0, 100, 'created_at', true).then((donationList: Donation[]) => {
        this.donationList = donationList;
        for (let donation of this.donationList) {
          if (donation.created_by && ((typeof donation.created_by === 'string'))) {
            donation.created_by = JSON.parse(donation.created_by);
          }
          if (donation.json_details && ((typeof donation.json_details === 'string'))) {
            donation.json_details = JSON.parse(donation.json_details);
          }
        }
        console.log(this.donationList);
        resolve(true);
      })
    })
  }


  saveDonation() {
    return new Promise((resolve) => {
      this.donation.created_by = this.auth.loggedInEmployee;
      this.donation.business_id = this.auth.loggedInEmployee.business_id;
      this.donation.committee_id = this.cs.committee.id;
      this.donation.member_id = this.cs.myMemberShip.id;
      this.donation.start_date = this.donation.start_date ?? new Date();
      this.donation.collected_amount = this.donation.collected_amount ?? 0;

      this.backEnd.saveObject(appConfig.STORAGE_TABLE.DONATION, this.donation).then((response) => {
        if (response) {
          this.donationList.push(this.donation);
          this.toast.success("Donation saved successfully");
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }


  getDonation(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.getSingle(appConfig.STORAGE_TABLE.DONATION, [[variable, id]]).then((donation: Donation) => {
        if (donation.created_by && ((typeof donation.created_by === 'string'))) {
          donation.created_by = JSON.parse(donation.created_by);
        }
        if (donation.json_details && ((typeof donation.json_details === 'string'))) {
          donation.json_details = JSON.parse(donation.json_details);
        }
        this.donation = donation;
        resolve(this.donation);
      })
    })
  }
  doCalculation() {
    this.backEnd.countObject(appConfig.STORAGE_TABLE.PAYMENT, [["donation_id", this.donation.id], ['status', 'Committed']], "amount").then((count: any) => {
      this.committedTotal = 0;
      this.committedTotal2 = 0;
      for (let key in count) {
        if (key + "" != "null") {
          this.committedTotal = this.committedTotal + (parseFloat(key) * count[key]);
        } else {
          this.committedTotal2 = this.committedTotal2 + (1 * count[key]);
        }
      }
    })
    this.backEnd.countObject(appConfig.STORAGE_TABLE.PAYMENT, [["donation_id", this.donation.id], ['status', 'Received']], "amount").then((count: any) => {
      this.receivedTotal = 0;
      this.receivedTotal2 = 0;
      for (let key in count) {
        if (key + "" != "null") {
          this.receivedTotal = this.receivedTotal + (parseFloat(key) * count[key]);
        } else {
          this.receivedTotal2 = this.receivedTotal2 + (1 * count[key]);
        }
      }
    })
    this.backEnd.countObject(appConfig.STORAGE_TABLE.PAYMENT, [["donation_id", this.donation.id], ['status', 'Denied']], "amount").then((count: any) => {
      this.deniedTotal = 0;
      this.deniedTotal2 = 0;
      for (let key in count) {
        if (key + "" != "null") {
          this.deniedTotal = this.deniedTotal + (parseFloat(key) * count[key]);
        } else {
          this.deniedTotal2 = this.deniedTotal2 + (1 * count[key]);
        }
      }
    })
  }

  getPaymentList() {
    return new Promise((resolve) => {
      let query = [];
      query.push(["donation_id", this.donation.id]);
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.PAYMENT, query, 0, 100, 'created_at', true).then((paymentList: Payment[]) => {
        this.paymentList = paymentList;
        for (let payment of this.paymentList) {
          if (payment.created_by && ((typeof payment.created_by === 'string'))) {
            payment.created_by = JSON.parse(payment.created_by);
          }
          if (payment.donor_meta && ((typeof payment.donor_meta === 'string'))) {
            payment.donor_meta = JSON.parse(payment.donor_meta);
          }
        }
        console.log(this.paymentList);
        resolve(true);
      })
    })
  }


  savePayment() {
    return new Promise((resolve) => {
      this.payment.created_by = this.auth.loggedInEmployee;
      this.payment.business_id = this.auth.loggedInEmployee.business_id;
      this.payment.committee_id = this.cs.committee.id;
      this.payment.donation_id = this.donation.id;
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.PAYMENT, this.payment).then((response) => {
        if (response) {
          let found = this.paymentList.find(x => x.id == this.payment.id);
          if (!found) {
            this.paymentList.unshift(this.payment);
          }
          this.toast.success("Payment saved successfully");
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }


  getPayment(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.getSingle(appConfig.STORAGE_TABLE.PAYMENT, [[variable, id]]).then((payment: Payment) => {
        if (payment.creator && ((typeof payment.creator === 'string'))) {
          payment.creator = JSON.parse(payment.creator);
        }
        if (payment.donor_meta && ((typeof payment.donor_meta === 'string'))) {
          payment.donor_meta = JSON.parse(payment.donor_meta);
        }
        this.payment = payment;
        resolve(this.payment);
      })
    })
  }
}
